import SettingsValidationObject from "newApp/entities/SettingsValidaionObject";

class SettingsValidation {
    constructor () {
    }

    validateAlphabeticalCharactersMinimumPasswordLengthRule (settings) {

        const lowercaseCharactersPolicy = settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.number;
        const uppercaseCharacters = settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.number;

        // Method should return false when sum of lowercaseCharacters + uppercaseCharacters is
        // greater than alphabeticalCharacters
        return settings.passwordPolicy.alphabeticalCharacters.number <= settings.passwordPolicy.minimumLength;
    }

    validateAlphabeticalCharactersSumOfFieldsRul (settings) {

        const lowercaseCharactersPolicy = settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.number;
        const uppercaseCharacters = settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.number;

        // Method should return false when sum of lowercaseCharacters + uppercaseCharacters is
        // greater than alphabeticalCharacters
        return lowercaseCharactersPolicy + uppercaseCharacters <= settings.passwordPolicy.alphabeticalCharacters.number;
    }

    validateNumericCharactersMinimumPasswordLengthRule = (settings) => {
        return settings.passwordPolicy.numericCharacters.number <= settings.passwordPolicy.minimumLength;
    };

    validatePunctuationOrOtherCharactersMinimumPasswordLengthRule = (settings) => {
        return settings.passwordPolicy.punctuationOrOtherCharacters.number <= settings.passwordPolicy.minimumLength;
    };

    validateMinimumLengthSumOfFieldsRule = (settings) => {
        return settings.passwordPolicy.alphabeticalCharacters.number +
            settings.passwordPolicy.numericCharacters.number +
            settings.passwordPolicy.punctuationOrOtherCharacters.number <= settings.passwordPolicy.minimumLength;
    };

    validateMinimumLengthRangeRule = (settings) => {
        return settings.passwordPolicy.minimumLength >= 8 && settings.passwordPolicy.minimumLength <= 25 || settings.settingsLocks.minimumLength;
    };

    validateMaximumAgeRangeRule = (settings) => {
        return settings.passwordPolicy.maximumAge > 0 || settings.settingsLocks.maximumAge;
    };

    validateAlphabeticalCharactersSumOfFieldsRule (settings) {

        const lowercaseCharactersPolicy = settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.number;
        const uppercaseCharacters = settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.number;
        // Method should return false when sum of lowercaseCharacters + uppercaseCharacters is
        // greater than alphabeticalCharacters
        return lowercaseCharactersPolicy + uppercaseCharacters <= settings.passwordPolicy.alphabeticalCharacters.number;
    }

    validateUppercaseCharactersMinimumAlphabeticalCharactersLengthRule (settings) {
        const uppercaseCharactersNumber = settings.passwordPolicy.alphabeticalCharacters.uppercaseCharacters.number;
        const alphabeticalCharactersNumber = settings.passwordPolicy.alphabeticalCharacters.number;

        return uppercaseCharactersNumber <= alphabeticalCharactersNumber;
    }

    validateLowercaseCharactersMinimumAlphabeticalCharactersLengthRule (settings) {
        const lowercaseCharactersNumber = settings.passwordPolicy.alphabeticalCharacters.lowercaseCharacters.number;
        const alphabeticalCharactersNumber = settings.passwordPolicy.alphabeticalCharacters.number;

        return lowercaseCharactersNumber <= alphabeticalCharactersNumber;
    }

    validateImage(logo) {
        const _maxLength = 1048576; //1Mb
        const _width = 200;
        const _height = 65;
        const fileTypes = ["image/jpeg", "image/png", "image/gif" ];

        var _isValid = true;

        //validate only new logos which was chosen just now
        if ( !logo || !logo.isNew ) {
            return _isValid;
        }

        if (logo.size > _maxLength
            || logo.width > _width
            || logo.height > _height
            || fileTypes.indexOf(logo.fileType) < 0
        ) {
            _isValid = false;
        }

        return _isValid;
    }

    createValidationObject (settings) {
        var object = new SettingsValidationObject();

        object.maximumAge.rangeRule.isValid = this.validateMaximumAgeRangeRule(settings);
        object.minimumLength.sumOfFieldsRule.isValid = this.validateMinimumLengthSumOfFieldsRule(settings);
        object.minimumLength.rangeRule.isValid = this.validateMinimumLengthRangeRule(settings);

        // Validate alphabetical characters settings
        object.alphabeticalCharacters.sumOfFieldsRule.isValid = this.validateAlphabeticalCharactersSumOfFieldsRule(settings);
        object.alphabeticalCharacters.minimumPasswordLengthRule.isValid = this.validateAlphabeticalCharactersMinimumPasswordLengthRule(settings);
        object.uppercaseCharacters.minimumAlphabeticalCharactersLengthRule.isValid = this.validateUppercaseCharactersMinimumAlphabeticalCharactersLengthRule(settings);
        object.lowercaseCharacters.minimumAlphabeticalCharactersLengthRule.isValid = this.validateLowercaseCharactersMinimumAlphabeticalCharactersLengthRule(settings);

        // Validate numeric characters settings
        object.numericCharacters.minimumPasswordLengthRule.isValid = this.validateNumericCharactersMinimumPasswordLengthRule(settings);

        // Validate punctuation-or-other settings
        object.punctuationOrOtherCharacters.minimumPasswordLengthRule.isValid = this.validatePunctuationOrOtherCharactersMinimumPasswordLengthRule(settings);

        object.isValid = object.maximumAge.rangeRule.isValid
            && object.minimumLength.sumOfFieldsRule.isValid
            && object.minimumLength.rangeRule.isValid
            && object.alphabeticalCharacters.sumOfFieldsRule.isValid
            && object.alphabeticalCharacters.minimumPasswordLengthRule.isValid
            && object.uppercaseCharacters.minimumAlphabeticalCharactersLengthRule.isValid
            && object.lowercaseCharacters.minimumAlphabeticalCharactersLengthRule.isValid
            && object.numericCharacters.minimumPasswordLengthRule.isValid
            && object.punctuationOrOtherCharacters.minimumPasswordLengthRule.isValid;

        return object;
    }
}

export default new SettingsValidation();

